import moment from 'moment'
import React, { useRef, useState } from 'react'
import { checkTranslation, getObject } from '../../utils/useful'
import tableComponents from '../tableComponents'
import FixedView from '../FixedView'


class TableRow extends React.Component {


  // componentDidUpdate(){

  // }
  // const row = useRef(null)


  // const indicatorMouseDown = (e) => {
  //     // pauseEvent(e)
  //     // if (e.stopPropagation) e.stopPropagation();
  //     // if (e.preventDefault) e.preventDefault();

  //     isDown = true
  //     document.addEventListener('mouseup', mouseUp)
  //     setTimeout(() => {
  //         cloneRow()
  //     }, 300);

  // }


  // const mouseUp = () => {
  //     isDown = false
  //     document.removeEventListener('mouseup', mouseUp)
  // }


  checkFilter(filter, source) {
    // console.log(filter)
    let result = null
    let currentOperator = "or"
    if (filter && Array.isArray(filter))
      if (filter.length == 1) {
        let operationResult = this.checkFilterCondition(filter[0], source)
        result = this.doOperation(result, currentOperator, operationResult)
      } else {
        filter.forEach(filterItem => {
          if (Array.isArray(filterItem)) {
            let operationResult = this.checkFilter([filterItem], source)
            // console.log("HERE")
            // console.log(this.checkFilter([filterItem],source))
            result = this.doOperation(result, currentOperator, operationResult)
          } else {
            currentOperator = filterItem
          }
        });
      }


    return result
  }

  doOperation(result, operation, operationResult) {
    // console.log(result)
    // console.log(operationResult)
    if (result == null) {
      return operationResult
    } else {
      switch (operation) {
        case ("or"):
          return result || operationResult
        case ('and'):
          return result && operationResult
      }
    }
  }

  checkFilterCondition(item, source) {

    let first = this.makeConditionValue(item[0], source)
    let condition = item[1]
    let second = this.makeConditionValue(item[2])

    switch (condition) {
      case ("=="):
        return first == second
      case ('>'):
        return first > second
      case ('<'):
        return first < second
      case ('<='):
        return first <= second
      case ('>='):
        return first >= second
    }
  }

  makeConditionValue(value, source) {
    let result = value
    if (typeof value == 'object' && !Array.isArray(value)) {
      if (value.key) {
        result = this.getObjectValue(value.key, source)
      }
      if (value.action && value.action == "date") {
        result = moment(new Date()).tz('Asia/Singapore').add(value.offset ? value.offset : 0, value.range ? value.range : 'days').valueOf()
        // console.log(result)
      }
    }
    // console.log(result)
    return result
  }



  getObjectValue(key, source) {
    if (source) {
      if (key.includes('.')) {
        return this.getObjectValue(key.split('.')[1], source[key.split('.')[0]])
      } else {
        return source[key]
      }
    } else {
      return null
    }
  }




  render() {
    // console.log(this.props.page?.indicators)
    let indicator = (this.props.page?.indicators && this.checkFilter(this.props.page?.indicators?.filter, this.props.data))
    // let borderColor = "#f9f9f9"
    // if (this.props.paymentTable && last) {

    //     if (moment(prop.dueDate).startOf('day').valueOf() != moment(last.dueDate).tz('Asia/Singapore').startOf('day').valueOf()) {
    //         borderColor = '#ccddee'
    //     }
    // }

    return (

      <div ref={el => this.row = el} className="tableRow" style={{ width: this.props.widths['*'], backgroundColor: indicator ? (this.props.page?.indicators?.color) : '#fff', }}>
        <div className='flexcc' ref={el => this.addWidgetButton = el} onMouseEnter={() => this.addWidgetFixedView.showView()} onMouseLeave={() => { this.addWidgetFixedView.hideView() }} style={{ background: this.props.data && this.props.data.importError ? '#ee505060' : '#fff', cursor: 'pointer' }}>

          {this.props.data && (this.props.data.importError || this.props.data.remark) && (
            <img className="m-1 " src="/images/icons/commentsIcon.png" alt="" width="12px" height='12px' />
          )}
          <FixedView zIndex={999} ref={el => this.addWidgetFixedView = el} nodeRef={this.addWidgetButton}  >
            <div className=" ml-0  flexcc flex-column" style={{ zIndex: 999, boxShadow: '0px 0px 15px #00000010', backgroundColor: '#fff', borderRadius: 8, marginTop: 15, maxWidth: 250, }}>
              {this.props.data.remark && (
                <div className='p-2 d-flex w-100' style={{ flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start' }}>

                  <p style={{ fontWeight: 500, fontSize: 12,textAlign:'start' }}>Remark:</p>
                  <p style={{ fontSize: 10,textAlign:'start' }} >{this.props.data.remark}</p>
                </div>
              )}
              {this.props.data.importError && (
                <div className='p-2 d-flex w-100 ' style={{ flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                  <p style={{ fontWeight: 500, fontSize: 12,textAlign:'start' }}>Review:</p>
                  <p style={{ fontSize: 10,textAlign:'start' }} >{this.props.data.importError}</p>
                </div>
              )}


            </div>
          </FixedView>
        </div>
        <div onClick={() => { this.props.openRow(this.props.data, this.props.index) }} className="flexcc" style={{ background: this.props.data && this.props.data.importError ? '#ee505060' : '#fff', cursor: 'pointer', zIndex: 1, flex: this.props.data && (this.props.data.importError || this.props.data.remark) ?'0 0 15px': '0 0 30px', width:  this.props.data && (this.props.data.importError || this.props.data.remark) ?'10px':'30px' }}>
          <p style={{ color: this.props.data && this.props.data.importError ? '#fff' : '#789', fontSize: 12 }}>{this.props.index + 1}</p>
        </div>

        {this.props.headers?.map((header, index) => {
          if (header.showMain != false) {

            let isSticky = false
            if (index === 0 && Math.abs(this.props.scrollX) > 5) {
              isSticky = true
            }
            let data = getObject(this.props.data, header.key)
            let Component = tableComponents[header.type]

            return (
              <div onClick={() => { if (index == 0) { this.props.openRow(this.props.data, this.props.index) } }} className={"tableBodyItem " + (isSticky ? 'stickytableBodyItem' : '')} key={header.key} style={{ transition: 'all 0.3', flex: index == 0 ? '1 0' : '0 0', maxWidth: index == 0 ? null : this.props.widths[header.key], flexBasis: this.props.widths[header.key], width: this.props.widths[header.key], cursor: index == 0 ? 'pointer' : '' }}>
              {Component && (
                <Component data={data} fullValues={this.props.data} header={header} />
              )}
            </div>
            )
          }
        })}


        {/* {this.props.settings?.extendedActions && this.props.actions?.map((prop, index) => {
                    let isSticky = false

                    return (
                        <div className={"tableBodyItem " + (isSticky ? 'stickytableBodyItem' : '')} key={header.key} style={{ transition: 'all 0.3', flex: index == 0 ? '1 0' : '0 0', maxWidth: index == 0 ? null : this.props.widths[header.key], flexBasis: this.props.widths[prop.key] }}>
                            <p >{checkTranslation(this.props.data[prop.key])}</p>
                        </div>
                    )
                })} */}

        {!this.props.settings?.extendedActions && this.props.actions && Object.values(this.props.actions).length > 0 && (
          <div className={"tableBodyItem px-3 py-1"} style={{ transition: 'all 0.3', flex: '0 0', maxWidth: this.props.widths['*actions'], flexBasis: this.props.widths['*actions'] }}>
            <button onClick={() => this.props.openActionsModal(this.props.data, this.props.index)} style={{ background: '#677dc415', borderRadius: 20, padding: '4px 12px' }}>
              <p className="text-smaller text-bold text-uppercase" style={{ color: '#677dc4aa' }}>{checkTranslation('actions')}</p>
            </button>
          </div>
        )}



      </div>


    )
  }

}

export default TableRow
